export default "/assets/images/graph-smoke.33f4ab62fce4a154.png";